var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Layout',[_c('h1',[_c('BaseIcon',{attrs:{"name":"user"}}),_vm._v(" "+_vm._s(_vm.user.name)+" Profile ")],1),_c('pre',[_vm._v(_vm._s(_vm.user))])])}
var staticRenderFns = []

export { render, staticRenderFns }